module.exports = __webpack_public_path__ + "static/media/7.10fbb840.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flight/landing/reviews/7.png
// module id = 1727
// module chunks = 0